export default {"src":"/_next/static/media/fireworks.mono.dc054fd4.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};